import React, { JSX } from 'react';
import type { DeviceConfigureOperation } from '../types/DeviceConfigureTypes';

type OperationSelectorProps = {
  value: DeviceConfigureOperation;
  onChange: (value: DeviceConfigureOperation) => void;
  canRunDeviceValidation?: boolean;
};

export default function OperationSelector(props: OperationSelectorProps): JSX.Element {
  const { value, onChange, canRunDeviceValidation = true } = props;
  return (
    <div className="border border-gray-100 dark:border-slate-700 rounded-lg p-3">
      <label className="block text-[11px] text-gray-700 dark:text-slate-300 mb-1">Operation</label>
      <select
        className="mt-1 w-72 rounded-md border border-gray-300 dark:border-slate-600 px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-slate-900"
        value={value}
        onChange={(e) => onChange(e.target.value as DeviceConfigureOperation)}
      >
        <option value="LEAVE_DEVICE_NOTE">Leave note on selected devices</option>
        <option value="SUBMIT_LIFECYCLE_REPORT">Submit lifecycle report</option>
        {canRunDeviceValidation ? (
          <option value="RUN_DEVICE_VALIDATION">Run device validation</option>
        ) : null}
        <option value="REMOVE_DEVICE_MAPPING">Remove from device mappings</option>
      </select>
    </div>
  );
}
